import 'slick-carousel'
import './plugins/accordion.plugin'
import './plugins/dropdown.plugin'
import './plugins/mobileNavigation.plugin'
import './plugins/stickyElement.plugin'
import './plugins/stickyHeader.plugin'
import './plugins/tabs.plugin'
import './plugins/jquery.rwd-fb-plugin'
import './plugins/randomPrices.plugin'
import './lib/smooth-scroll'


$(function () {
    $('header.primary').stickyHeader();
    $('nav.primary').dropdown();

    $('.random-prices').randomPrices('.random-price');

    //facebook plugin responsiveness
    $('.fb-page').rwd();


    $('form.zip-code-search').submit(function(e) {
        e.preventDefault();

        var zipCode = $(this).find('input[name="zip_code"]');

        if (!zipCode.val()) {
            zipCode.prop('placeholder', 'Enter a Zip Code');
            return;
        }

        window.location = $(this).prop('action') + zipCode.val();
    });

    var $accordion = $('div.accordion');
    $accordion.accordion({
        singleOpen: false
    });

    // Mobile Navigation
    $('.mobile').mobileNavigation();
});
